import React from 'react'

import Heading from '@react/react-spectrum/Heading'
import MediaUpload from 'components/MediaUpload'

export default function ({ branding, project, disabled, onChange }) {
  return (
    <>
      <section>
        <Heading size='4'>Main Logo</Heading>

        <MediaUpload
          type='image'
          value={branding.logo}
          heading='Drag and Drop'
          onUpload={onChange('logo')}
          projectId={project?.meta?.id}
          path={'branding-logo'}
          withTextfield={true}
          disabled={disabled}
        />
      </section>
    </>
  )
}
